import PropTypes from 'prop-types';
import CopyButton from '../common/CopyButton';

const CustomText = ({ heading, text, addCopyButton, textUp }) => {
    return (
        <div className="self-stretch inline-flex justify-start items-center gap-2">
            <div className="flex-1 inline-flex flex-col justify-start items-start gap-1.5">
                <div className="self-stretch justify-center text-balanceCard-manage text-xs font-medium  uppercase leading-none">
                    {heading}
                </div>
                <div
                    className={`justify-center !text-text text-sm font-medium leading-tight 
                        ${textUp ? ' uppercase' : ''}
                    `}>
                    {text || '-'}
                </div>
            </div>
            {addCopyButton ? <CopyButton copyValue={text || '-'} /> : null}
        </div>
    );
};

CustomText.propTypes = {
    heading: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    addCopyButton: PropTypes.bool,
    textUp: PropTypes.bool,
};

export default CustomText;
